import { CreatedFrom } from 'src/modules/homeownerApp/static_values';
import type { AiDisplayImageFragment } from 'src/shared/graphql/generated';

/**
 * Returns tracking data for the display image based on its origin. The returned data
 * includes ai_original_image_id if the target is the original image or
 * ai_generated_image_id if the target is a generated image. It never
 * returns both ai_original_image_id and ai_generated_image_id to allow
 * distinguishing what was customized in the tracking data.
 */
export const getDisplayImageTracking = (image: AiDisplayImageFragment) => {
  if (image.createdFrom === CreatedFrom.ORIGINAL) {
    return {
      ai_display_image_id: image.id,
      ai_original_image_id: image.aiOriginalImageId,
      style: image.style ?? undefined,
      space_type: image.spaceType ?? undefined,
    };
  }

  return {
    ai_display_image_id: image.id,
    ai_generated_image_id: image.aiGeneratedImage.id,
    style: image.style ?? undefined,
    space_type: image.spaceType ?? undefined,
  };
};
